exports.IDS = {
  // IMG_URL: "http://127.0.0.1:1515",

  // IMG_URL: "https://gnkumbharnode.profcyma.org:2116",

  IMG_URL: "https://node.gnkumbar.com",

  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },

  Section: {
    Home_Page: 1,
    About_Us: 2,
    Blog: 3,
    Blog_Inner: 4,
    Contact_Us: 5,
    Explore_Products: 6,
    Explore_Products_Inner: 7,
    Faq: 8,
    Gallery: 9,
    Gallery_Inner: 10,
    Privacy_Policy: 11,
    Terms_Of_Services: 12,
  },
};
